import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-hot-toast";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import PersonAddAltSharpIcon from "@mui/icons-material/PersonAddAltSharp";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import { useTranslation } from "react-i18next";
import ModalForGuest from "../ModalForGuest";

const Connection = ({
  userData,
  setDisconectCheck,
disconectCheck,
  uid,
  connectionCheck,
  setConnectionCheck,
  connectionId,
  CheckConnectUser,
  onConnectionSuccess,
  connectionFromModal = false,
  onConnectionRejected,
  showCancelRequestModal = false,
}) => {
  const sessionId = localStorage.getItem("sessionId");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const { t } = useTranslation();
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);
  const language = localStorage.getItem("Lang");
  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const guestModeData = localStorage.getItem("guestMode");


  // console.log("checkconnection111111", userData.profileInfo.isConnectedByYou);
  //************************ Connect User Start  ************************//

  const [followModal, setFollowModal] = useState(false);
      const closeModalData = () => {
          setFollowModal(false);
      };

  const ConnectUser = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post("Connection/SendConnectionRequest", data)
        .then((resData) => {
          if (connectionFromModal) {
            onConnectionSuccess(resData, "success");
          } else {
            //   toast.success(resData.data.message);
            setConnectionCheck("Sent"); 
            setToastMessage(resData.data.message);
            setShowToast(true);
            CheckConnectUser();
            // CheckFollowedUser();
          }
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        if (connectionFromModal) {
          onConnectionSuccess(error.response, "error");
        } else {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        }
      } else {
        if (connectionFromModal) {
          onConnectionSuccess(error?.response, "error");
        } else {
          setErrorToastMessage(error?.response?.data?.message);
          setShowErrorToast(true);
        }
      }
    }
  };

  //************************ Connect User  End  ************************//

  const handleRecommendConnect = () => {};
  //************************Cancel Request   ************************//
  const [show, setShow] = useState(false);
  const cancelRequestClose = () => {
    setShow(false);
  };
  
  // const [skillId, setSkillId] = useState("");
  // const [userUID, setuserUID] = useState("");
  const CancelRequest = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
      langKey: language === "en" ? "" : language,
    };
    console.log(data);
    try {
      await axios
        .post("Connection/CancelConnectionRequest", data)
        .then((resData) => {
          console.log("===>",resData);
           setShow(false);          // close modal
           setConnectionCheck(null); 
          // setShow(!show);
          //   toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
          CheckConnectUser();
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Cancel Request ************************//

  //************************Disconnect Request   ************************//
  const [disconectshow, setDisconectShow] = useState(false);
  const DisconnectClose = () => {
    setDisconectShow(false);
  };
   const AcceptRequest = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
      connectID: connectionId,
      actionType: "Accept",
      langKey: language === "en" ? "" : language,
    };
    console.log(data);
    try {
      await axios
        .post("Connection/ConnectionRequestAction", data)
        .then((resData) => {
          console.log(resData.data.message);
          //   toast.success(resData.data.message);
            setConnectionCheck("Disconnected"); 
          setToastMessage(resData.data.message);
          setShowToast(true);
          setDisconectCheck(true)
          CheckConnectUser();
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Accept Request ************************//

  //************************Reject Request   ************************//
  const RejectRequest = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
      connectID: connectionId,
      actionType: "Reject",
      langKey: language === "en" ? "" : language,
    };
    console.log(data);
    try {
      await axios
        .post("Connection/ConnectionRequestAction", data)
        .then((resData) => {
          console.log(resData.data.message);
          //   toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
          CheckConnectUser();
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Reject Request ************************//

  // useEffect(() => {
  //   CheckConnectUser();
  // }, [uid]);
  // console.log("checkFollowedUser", connectionCheck);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [show]);

  useEffect(() => {
    if (showCancelRequestModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  
    return () => {
      document.body.classList.remove("modal-open"); // Cleanup when modal is closed
    };
  }, [showCancelRequestModal]);

  
  return (
    <>
      <div className="connectionButton ">
        {/* {checkconnection === false? ( */}
        {connectionCheck === "Sent" ? (
          <button
            type="button"
            className="wljSecondaryBtn cbtn me-md-3 wlj-chip-btn"
            onClick={() => {
              if (connectionFromModal) {
                onConnectionRejected(true);
              } else {
                setShow(!show);
              } 
            }}
          > 
            <CloseSharpIcon />
            {t("Recommendations.Cancel Request")}
          </button>
        ) : connectionCheck === "Received" ? (
          <>
            <button
              type="submit"
              className="wljPrimaryBtn me-3 wlj-chip-btn"
              onClick={() => {
                AcceptRequest();
              }}
            > 
              <CheckSharpIcon />
              {t("Connections.Accept")}
            </button> 
          </>
        ) : disconectCheck === true ? (
          ""
        ) : (
          <button type="button" className="wljPrimaryBtn me-3 wlj-chip-btn" 
          onClick={() => {
                    guestModeData === "true"
                        ? setFollowModal(true)
                        : ConnectUser();
                }}
          >
            <PersonAddAltSharpIcon />
            {t("Recommendations.Connect")}
          </button>
        )}
      </div>


     

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />


       {show && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are You Sure You want to Cancel Request?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    cancelRequestClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => CancelRequest()}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
         {followModal && <ModalForGuest closeModalData={closeModalData} />}

    </>
    
  );
  
};

export default Connection;
